<template>
	<section class="page">
		<due-tabs v-model="activeName"></due-tabs>

		<div class="content-box">
			<div class="operator">
				<div class="operator-col">
					<hispickup v-model="filterHisDate"></hispickup>
				</div>
				<div class="operator-col">
					<agent-input :params="{type: 'Agent',allowCreate: false}" v-model="filterCustomer"></agent-input>
				</div>
				<div class="operator-col">
					<product-input :params="{allowCreate: false,placeholder:'SPU 名/码'}" v-model="filterProducts"></product-input>
				</div>
        <div class="operator-col">
          <admin-input
              :params="{allowCreate: false, notUseMeAsDefault:true,placeholder:'销售',kvFilter:adminFilter}"
              v-model="filterSaler"
          ></admin-input>
        </div>
				<div class="operator-col">
					<el-input
							size="mini"
							v-model="filterTableSearch"
							placeholder="单号"
							suffix-icon="el-icon-search"
					></el-input>
				</div>
			</div>
			<sum-table
				ref="sumTable"
				data-model="Order"
				:search-filter="filterTableSearch"
				:date-filter="filterHisDate"
				:kv-filter="kvFilter"
				:fields="sumFields"
				list-url="orderm/sums/reserve"
			></sum-table>
			<curd-table
				ref="listTable"
				data-model="Order"
				:has-op-slot="true"
				:fields="tableFields"
				:has-delete="false"
				list-url="orderm/lists/reserve"
				:search-filter="filterTableSearch"
				:date-filter="filterHisDate"
				:kv-filter="kvFilter"
				:has-expand-show="true"
			>
				<template slot="expandShow" slot-scope="scope">
					<div class="row">
						<div class="col-md-6">
							<h5>备注</h5>
							<p>{{scope.row.desc}}</p>
						</div>
						<div class="col-md-6">
							<h5>单据/截图</h5>
							<p>
								<img :src="scope.row.primary_img" class="img-fluid order-img" />
							</p>
						</div>
					</div>
					<table class="table table-bordered">
						<thead>
							<tr>
								<th
									v-for="(key,index) in itemTableFields"
									:key="index"
								>{{dataModels.Order_item[key.name].show_name}}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="tx_item in scope.row.order_items" :key="tx_item._id">
								<td v-for="(key,index) in itemTableFields" :key="index">
									<field-show
										:field-info="dataModels.Order_item[key.name]"
										:value="tx_item[key.name]"
										:field-key="key"
									></field-show>
								</td>
							</tr>
						</tbody>
					</table>
				</template>
				<template slot="listOp" slot-scope="scope">
					<el-button size="mini" type="text" @click="goInfo(scope.row._id)">详情</el-button>
					<el-button size="mini" type="text" @click="changeLock(scope.row._id)">预留锁</el-button>
					<el-button size="mini" type="text" @click="goCheckTx(scope.row._id)" v-if="scope.row.status.index==10">派单</el-button>
				</template>
			</curd-table>
		</div>
		<pay-editor
			:show.sync="payEditorVisible"
			:record-id="payEditorId"
			@change="refreshTable('listTable')"
			v-if="payEditorVisible"
		></pay-editor>
	</section>
</template>

<script>
import TabPage from "@/mixins/TabPage.js";
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterCustomer from "@/mixins/Filter/FilterCustomer.js";
import FilterProducts from "@/mixins/Filter/FilterProducts.js";
import DueTabs from "@/views/Order/widgets/DueTabs.vue";
import FilterSaler from "@/mixins/Filter/FilterSaler.js";
import { RenderOrderLists, RenderSaler } from "@/mixinsApp/Render.js";

import LoadDM from "@/mixins/LoadDM.js";
import OrderOp from "@/mixinsApp/OrderOp.js";

export default {
	mixins: [TabPage, OrderOp, Filters, FilterCustomer, FilterProducts, CurdPage, LoadDM, FilterSaler],
	data() {
		return {
			activeName: "reserve",
			dataModelNames: ["Order", "Order_item"],
			tableFields: [
				{
					name: "show_id",
					sortable: "custom",
					isBold: true,
					needThumb: "primary_img",
				},
				{
					name: "customer",
					sortable: "custom",
					width: "90px",
				},
				{
					name: "express_type",
					render: info => {
						return "[" + info.express_type.name + "] " + info.address.name;
					},
				},
				{
					name: "saler",
					render: RenderSaler,
				},
				{
					name: "name",
					width: "300px",
					params: {
						multiHidden: true,
					},
					render: RenderOrderLists,
				},
				{
					name: "total_price",
					sortable: "custom",
					isTag: true,
				},
				{
					name: "has_payed",
					sortable: "custom",
				},
				{
					name: "payed_at",
					sortable: "custom",
				},
				{
					name: "created_at",
					sortable: "custom",
				},
				{
					name: "status",
					sortable: "custom",
				},
				{
					name: "reserved_lock",
					sortable: "custom",
				}
			],
		};
	},
	components: { DueTabs },
	methods:{
		changeLock(id){
			this.$axios.post(`/orderm/do_reserved_lock/${id}`)
					.then((json) => {
						if(json.rstno == 1){
							this.$message({
								type: "success",
								message: '操作成功',
							});
							this.refreshTable("listTable");
						}else {
							this.$message({
								type: "error",
								message: json.data.msg,
							});
						}
					})
					.catch(function (error){
						console.log(error)
					})
		}
	}
};
</script>
<style lang="scss" scoped>
</style>
